module.exports = __webpack_public_path__ + "img/lg_ring_r_e_null_1@3x.c67b2809.png";